import React from 'react';
import classnames from 'classnames';
import numeral from 'numeral';

const BomItem = (props) => {
  const {
    line_in_file,
    identifier,
    description,
    qty_to_buy,
    unit_price,
    price_by_qty,
    user_action,
    reference_designator,
    qty_per_board,
    estimated_tariff,
    tariff_may_be_applied_after_purchase,
  } = props;

  return (
    <tr className={classnames('', {
        'bg-will-provide': user_action == 'will_provide',
        'bg-dont-populate': user_action == 'do_not_populate',
        'bg-tariff-may-apply': tariff_may_be_applied_after_purchase,
      })}>
      <td className='text-center'>{line_in_file}</td>
      <td>{identifier}</td>
      <td>{reference_designator}</td>
      <td>{description}</td>
      <td className='text-center'>{qty_per_board}</td>
      <td className='text-center'>{qty_to_buy}</td>
      <td className={classnames('', {
          'text-center': unit_price == "-",
          'text-end': unit_price != "-"
        })}>
        {unit_price == "-" && unit_price}
        {unit_price != "-" && `${numeral(unit_price).format('0.00')}`}
      </td>
      <td className={classnames('', {
          'text-center': price_by_qty == "-",
          'text-end': price_by_qty != "-"
        })}>
        {price_by_qty == "-" && price_by_qty}
        {price_by_qty != "-" && `${numeral(price_by_qty).format('0.00')}`}
      </td>
      <td className={classnames('', {
          'tariff-may-apply': tariff_may_be_applied_after_purchase,
          'text-center': !tariff_may_be_applied_after_purchase && estimated_tariff <= 0,
          'text-end': estimated_tariff > 0
        })}>
        {tariff_may_be_applied_after_purchase && <span><i className="fas fa-dollar-sign"></i></span>}
        {!tariff_may_be_applied_after_purchase && estimated_tariff <= 0 && '-'}
        {!tariff_may_be_applied_after_purchase && estimated_tariff > 0 && `${numeral(estimated_tariff).format('0.00')}`}
      </td>
    </tr>
  )
}

export default BomItem;